import styled, { keyframes } from "styled-components";
import { Checkbox } from 'antd';
import { Link } from "react-router-dom";
const isMobile = window.innerWidth < 768;

const fadeIn = keyframes`
  0% { opacity: 0; }
  100% { opacity: 1; }
`;

const fadeOut = keyframes`
  0% { opacity: 1; }
  100% { opacity: 0; }
`;

export const StyledAuth = styled.div`
    // height: 100%;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    padding: 40px;
    padding-top: ${isMobile ? '60px'  : '160px' };
    padding-bottom: ${isMobile ? '0px'  : '80px' };

    background-color: rgba(251, 247, 240, 1);
    
    &.fade-in {
        animation: ${fadeIn} 300ms ease-in;
    }

    &.fade-out {
        animation: ${fadeOut} 300ms ease-out;
    }
`;

export const StyledCheckbox = styled(Checkbox)`
    color: rgba(76, 76, 77, 1);
    .ant-checkbox-checked .ant-checkbox-inner {
        background-color: orange !important;
        border-color: orange !important;
    }

    .ant-checkbox-inner {
        border-color: rgb(134, 134, 134) !important;
    }

    .ant-steps-item-process .ant-steps-item-container {
        color: white !important;
    }
`;

export const StyledLink = styled(Link)`
    color: orange !important;
    margin-bottom: 8px !important;
`;
